import styled from "styled-components";
import "../../styles/variables.css";

export const AccordionContainer = styled.div<{ open: boolean }>`
  width: 100%;
  height: ${({ open }) => (open ? "150px" : "30px")};
  transition: all 0.15s ease-in-out;
  overflow-y: hidden;
  border-bottom: 1px solid var(--bg-light-button);
  padding: 10px 0;
  label {
    font-weight: 400;
    font-size: var(--fs14);
    color: var(--secondary-text-color);
  }
`;

export const AccordionQuestion = styled.div`
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    font-size: var(--fs15);
  }
`;

export const AccordionButton = styled.div<{ open: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--bg-light-button);
  cursor: pointer;
  svg {
    transition: all 0.15s ease-in-out;
    transform: rotate(${(props) => (props.open ? 180 : 0)}deg);
  }
`;
